module.exports = __webpack_public_path__ + "static/media/checkbox-off-white.c48d9267.svg";